import iamHttp from '@/plugins/http/iam';

interface Permission {
  permission: string;
  model?: string;
  relation?: string;
  object?: string;
}

interface CheckUserRequest {
  permissions: Permission[];
}

interface CheckUserResponse {
  sub: string;
  email: string;
  email_verified: boolean;
  permissions: Permission[];
}

/**
 * Check if the current user is an admin by calling the Pharia IAM /check_user endpoint.
 * This replaces the previous Zitadel-based role checking.
 */
export async function isAdminUser(): Promise<boolean> {
  try {
    const request: CheckUserRequest = {
      permissions: [
        {
          permission: 'Admin',
        },
      ],
    };

    const httpResponse = await iamHttp.post('check_user', { body: request });
    const response = httpResponse.data as CheckUserResponse;

    // Check if the user has the Admin permission
    const hasAdmin = response.permissions.some((p) => p.permission === 'Admin');
    return hasAdmin;
  } catch (error) {
    return false;
  }
}
